import { render, staticRenderFns } from "./DxfLayersList.vue?vue&type=template&id=79f3f458&scoped=true&"
import script from "./DxfLayersList.vue?vue&type=script&lang=js&"
export * from "./DxfLayersList.vue?vue&type=script&lang=js&"
import style0 from "./DxfLayersList.vue?vue&type=style&index=0&id=79f3f458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f3f458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VList,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow})
